//providers
import { useAppContext } from "providers/app"
import { useUsersDataContext } from "../providers/users"

//hooks
import useFetch from "hooks/useFetch"

//constants
import { ENDPOINTS } from "constants/endpoints.js"

function useDeactivateUser(userId, deactivateUserRef) {
    const { fetch } = useFetch()

    const app = useAppContext()
    const users = useUsersDataContext()

    function handleDeactivate() {
        fetch({
            endpoint: `user/deactivate?user_id=${userId}`,
            method: "get",
        })
            .then(() => {
                users.refetchAllData()
                app
                    .handleMessage()
                    .success()
                    .show("Потребителят беше деактивиран успешно!")
            })
            .catch(() => {
                app
                    .handleMessage()
                    .error()
                    .show("Нещо се обърка! Моля, опитайте отново.")
            })
            .finally(() => {
                deactivateUserRef.current.close()
            })
    }

    return {
        handleDeactivate
    }
}

export default useDeactivateUser